import { GetCurrentUserResponse } from 'api/actions/get-current-user/get-current-user-response';
import { createContext, useContext } from 'react';

export type CurrentBuilding = NonNullable<GetCurrentUserResponse['buildings']>[number];

export const SimpleLayoutBuildingContext = createContext<CurrentBuilding | null>(null);

/**
 * Returns the current building provided by SimpleLayout.
 *
 * @returns {CurrentBuilding | null}
 */
export function useSimpleLayoutBuilding() {
  return useContext(SimpleLayoutBuildingContext);
}
